import { Theme } from '@/ui-components/constants/theme'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UserState {
  isUpdating?: boolean | undefined
  token?: string | undefined
  accessToken?: string | undefined
  userName?: string | undefined
  userId?: number | undefined
  providerId?: number | undefined
  ipAddeess?: string | undefined
  userBalance?: number | undefined
  userBalanceUpdatedTime?: string | undefined
  logoUrl?: string | undefined
  logoUrlDark?: string | undefined
  logoLinkUrl?: string | undefined
  faviconUrl?: string | undefined
  title?: string | undefined
  theme?: Theme | undefined
  provider?: {
    defaultLanguage?: string | undefined
    languages?: string[] | undefined
    currency?:
      | {
          code?: string | undefined
          symbol?: string | undefined
          name?: string | undefined
          locale?: string | undefined
          decimalPlaces?: number | undefined
          position?: 'before' | 'after' | undefined
          minRunningBet?: number | undefined
          betSetPrice?: number[] | undefined
        }
      | undefined
  }
}

const initialState: UserState = {
  token: undefined,
  accessToken: undefined,
  userName: undefined,
  userId: undefined,
  providerId: undefined,
  ipAddeess: undefined,
  userBalance: undefined,
  userBalanceUpdatedTime: undefined,
  logoUrl: undefined,
  logoUrlDark: undefined,
  logoLinkUrl: undefined,
  faviconUrl: undefined,
  title: undefined,
  isUpdating: false,
  provider: undefined,
  theme: undefined,
}

const ListUserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPlayerToken: (state, action: PayloadAction<UserState>) => {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})
export const getPlayerId = (state: { user: UserState }) => state.user.userId
export const { setPlayerToken } = ListUserSlice.actions
export default ListUserSlice
